// extracted by mini-css-extract-plugin
module.exports = {"paper":"a3-qr-20x20_paper__2QUDH","page":"a3-qr-20x20_page__3adEW","label":"a3-qr-20x20_label__2G8VQ"};